import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import { useRouter } from 'next/router';
import { Button } from 'antd';
import If from 'global/ErrorHandlers/If';
import { useBondTransaction } from '../../stores/useBondTransaction';
import { useBondsModalStore } from '../../stores/useBondsModalStore';
import { BondBlockerType } from '../../constants';
import { ModalBody, ModalContainer, ModalHeader } from '../../styled';
import { ContentContainer, Heading, Logo } from './styled';
import { BOND_BLOCKER_CONFIG } from './constants';

interface Props {
  onClose: () => void;
}

export default function ModalBondBlockers({ onClose }: Readonly<Props>) {
  const router = useRouter();
  const productId = useBondTransaction((s) => s.productId);
  const { blockerType } = useBondsModalStore((s) => ({
    blockerType: s.blockerType,
  }));

  const { iconSrc, title } = BOND_BLOCKER_CONFIG[blockerType];

  const handleGotoSector = () => {
    router.push('/catalog/fr-bonds/');
  };

  return (
    <ModalContainer>
      <ModalHeader>
        {/* @ts-expect-error */}
        <Flex justify="space-between" align="start" w="100%">
          <Logo alt={`${title} illustration`} src={iconSrc} />
          <Iconmoon
            className="icon-trading_x"
            color="#333333"
            size="12px"
            onClick={onClose}
          />
        </Flex>
      </ModalHeader>
      <ModalBody>
        <ContentContainer>
          <If condition={blockerType === BondBlockerType.MAINTENANCE}>
            <Heading>Maintenance Sedang Berlangsung</Heading>
            <Text align="center">
              Transaksi Obligasi Pasar Sekunder tidak bisa dilakukan untuk
              sementara. Silahkan coba lagi nanti.
            </Text>
          </If>

          <If condition={blockerType === BondBlockerType.PRICE_CHANGED}>
            <Heading>Terjadi Perubahan Harga</Heading>
            <Text align="center">
              Harga telah berubah mengikuti harga pasar saat ini
            </Text>
          </If>

          <If condition={blockerType === BondBlockerType.STABLE_EARN}>
            <Heading>
              Stable Earn Hanya Dapat Dijual Melalui Aplikasi Bibit
            </Heading>
          </If>

          <If condition={blockerType === BondBlockerType.MARKET_CLOSE}>
            <Heading>Market Sedang Tutup</Heading>
            <Flex direction="column" align="center">
              <Text>Market akan buka kembali dalam</Text>
              <Text color={color.primary}>15-20 menit.</Text>
            </Flex>
          </If>

          <If condition={blockerType === BondBlockerType.TEMPORARY_UNAVAILABLE}>
            <Heading>{productId} Sedang Tidak Tersedia</Heading>
            <Text align="center">
              Saat ini sedang dilakukan proses pencatatan untuk pembagian kupon
              obligasi {productId}. Transaksi {productId} dapat dilakukan
              kembali dalam{' '}
              <Text as="span" color={color.primary}>
                1 - 2 hari bursa
              </Text>
              .
            </Text>
          </If>

          <If condition={blockerType === BondBlockerType.UNAVAILABLE}>
            <Heading>Sementara Tidak Dapat Dibeli</Heading>
            <p>Silahkan coba produk Obligasi FR lainnya.</p>
            <Button type="primary" onClick={handleGotoSector} block>
              Lihat Produk Obligasi FR
            </Button>
          </If>

          <If condition={blockerType === BondBlockerType.SHARIA_VALIDATION}>
            <Heading>Bukan FR Syariah</Heading>
            <p>
              Kamu tidak bisa bertransaksi FR non-syariah.
              <br />
              <b>(Fatwa No.80/DSN-MUI/III/2011)</b>
            </p>
            <Button
              type="primary"
              onClick={onClose}
              css={`
                width: 200px;
              `}
              block
            >
              Oke
            </Button>
          </If>
        </ContentContainer>
      </ModalBody>
    </ModalContainer>
  );
}
